import { FC } from "react";

import { Scope, ScopeResource } from "src/authentication/PermissionsProvider";
import { usePermissions } from "src/authentication/usePermissions";
import { BasicWidgetProps } from "src/dynamic-view-renderer/Widgets/BasicWidget/BasicWidget.tsx";

import WidgetBlacklistSchema from "./WidgetBlacklistSchema";
import WidgetCaseSchema from "./WidgetCaseSchema";
import WidgetCustomerSchema from "./WidgetCustomerSchema";

const WidgetSchema: FC<Omit<BasicWidgetProps, "itemSchema">> = (props) => {
  const itemType = props.data?.item?.type;
  const { hasPermission } = usePermissions();

  switch (itemType) {
    case "blacklist":
      return <WidgetBlacklistSchema {...props} />;
    case "customer":
      if (!hasPermission(ScopeResource.CUSTOMER, Scope.VIEW)) {
        return null;
      }
      return <WidgetCustomerSchema {...props} />;
    default:
      return <WidgetCaseSchema {...props} />;
  }
};

export default WidgetSchema;
